// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message_box {
    min-width: 50rem;
}

.message-box__header {
    width: 100%;
    height: 10%;
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0;
}

.message-box__title {
    margin: inherit;
    padding: inherit;
    text-align: left;
    width: 90%;
    font-size: 2rem;
}

.message-box__close {
    width: 20%;
    background-color: #d22e37;
    border: none;
}

.message-box__body {
    height: 90%;
    outline: none;
    border: none;
    resize: none;
    width: 100%;
    word-wrap: break-word;
    font-size: 2rem;
}

.message-box__footer {
    width: 100%;
    text-align: right;
}

.message-box__confirm-buttons--reject {
    background-color: #d22e37;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/message-boxes/message-box/MessageBox.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".message_box {\r\n    min-width: 50rem;\r\n}\r\n\r\n.message-box__header {\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.message-box__title {\r\n    margin: inherit;\r\n    padding: inherit;\r\n    text-align: left;\r\n    width: 90%;\r\n    font-size: 2rem;\r\n}\r\n\r\n.message-box__close {\r\n    width: 20%;\r\n    background-color: #d22e37;\r\n    border: none;\r\n}\r\n\r\n.message-box__body {\r\n    height: 90%;\r\n    outline: none;\r\n    border: none;\r\n    resize: none;\r\n    width: 100%;\r\n    word-wrap: break-word;\r\n    font-size: 2rem;\r\n}\r\n\r\n.message-box__footer {\r\n    width: 100%;\r\n    text-align: right;\r\n}\r\n\r\n.message-box__confirm-buttons--reject {\r\n    background-color: #d22e37;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
